// extracted by mini-css-extract-plugin
export var columnList = "_ew-0";